export default {
  state: {
    realgrid: {
      list: {
        codeYn: [{ label: 'Y', value: 'Y' }, { label: 'N', value: 'N' }],
        fieldType: [
          { label: 'string', value: 'string' },
          { label: 'number', value: 'number' }
        ]
      }
    }
  }
}
